   <div class="main-content">
      <div class="container-fluid">
        <mat-accordion>
          <ng-container *ngFor="let branch of Branches; let i = index" >
               <mat-expansion-panel [expanded]="i === 0" *ngIf="branch?.Orignaldevices">
            <mat-expansion-panel-header class="right-aligned-header">
              <mat-panel-title class="row header-content">
                <div class="col-12 col-md-4">
                  <span class="titles">{{ branch?.name }}</span>
                </div>
                <div class="col-12 col-md-4">
                  <span class="titles">#Devices: {{ branch.Orignaldevices?.length }}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="row">
              <div *ngFor="let device of branch?.Devices; let i = index" class="col-md-6 mb-4">
                <mat-card class="h-100">
                  <mat-card-header>
                    <mat-card-title>{{ device.DeviceNickName }}</mat-card-title>
                    <mat-card-subtitle> Measurement Type: {{ device.devicetype }}</mat-card-subtitle>
                   
                  </mat-card-header>
                  
                  <mat-card-content>
                    <div class="text-center mt-3">
                      <!-- <ngx-gauge
                        [size]="325"
                        type="arch"
                        thick="50"
                        [value]="device.adjustedValue"
                        cap="butt"
                        [label]="device.label"
                        [markers]="device.markerConfig"
                        [thresholds]="device.thresholdsConfig"
                        [max]="device.gaugeMax"
                        [min]="device.gaugeMin">
                      </ngx-gauge> -->

                      <div class="text-center mt-3 gauge-container">
                        <ngx-gauge
                          [size]="getGaugeSize()"
                          type="arch"
                          thick="50"
                          [value]="device.adjustedValue"
                          cap="butt"
                          [label]="device.label"
                          [markers]="device.markerConfig"
                          [thresholds]="device.thresholdsConfig"
                          [max]="device.gaugeMax"
                          [min]="device.gaugeMin">
                        </ngx-gauge>
                      </div>

                    </div>
                    
                    <div class="mt-3 text-start">
                      <p class="mb-2">
                        <strong>Last Updated:</strong> 
                        {{ formatTimestamp(device.timestamp) }}
                      </p>
                      <p class="mb-2">
                        <strong>Status:</strong> 
                        <span [ngClass]="getStatusClass(device.timestamp)">
                          {{ getDeviceStatus(device.timestamp) }}
                        </span>
                      </p>
                      <p class="mb-0"><strong>Location:</strong> {{ device.branch }}</p>

                    </div>
                
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-expansion-panel>
          </ng-container>
       
        </mat-accordion>
      </div>
    </div> 



 
